import { Injectable } from '@angular/core';

export abstract class Logger {

  info: any;
  debug: any;
  warn: any;
  error: any;
}

@Injectable()
export class DipRegistrationLoggerService implements Logger {

  info: any;
  debug: any;
  warn: any;
  error: any;
}
